import React, {useEffect, useState} from 'react';
import { Link, useParams } from "react-router-dom";

import AppContext from "../../app-context";
import {socketUseEffect} from "../../socket";

import PageTitle from "../core/page-title";

import SideBar from "../core/dashboards/sidebar";
import MainDashboardContent from "../core/dashboards/section"

import Dashboard from "./sub-pages/push/dashboard";
import Generator from "./sub-pages/push/generator";
import {useAuth} from "../../AuthContext";
import {IconEdit, IconLayoutDashboard, IconPalette, IconPlug, IconTrash} from "@tabler/icons-react";
import Plugins from "./sub-pages/wordpress/plugins";
import CustomTest from "./custom_test";
import Servers from "./servers";

const PushTestsDashboard = (props) => {
    const [details, setDetails] = useState({name: "Loading..."})
    const { id, page } = useParams();

    const [refresh, setRefresh] = useState(true);

    const { user } = useAuth();
    const listeners = [
        {name: "custom_tests", fn: "get", args: {user_id: user.user_id, id: id}, saveDataFN: setDetails, row: "0"},
    ]
    useEffect(() => socketUseEffect(listeners, user), [id, page, refresh]);

    let tabs = [
        { label: "Dashboard", page: "dashboard", link: "/push-test/:id/dashboard", controller: Dashboard },
        { label: "Generator", page: "generator", link: "/push-test/:id/generator", controller: Generator },
        { label: "Edit", page: "edit", link: "/push-test/:id/edit", controller: CustomTest, args: {edit: 1, id, details, refresh, setRefresh} },
        { label: "Remove", page: "delete", link: "/push-test/:id/delete", controller: CustomTest, args: {delete: 1, id, details, refresh, setRefresh} },
    ];

    const icons = {
        dashboard: <IconLayoutDashboard size={20} />, // Profile Icon
        generator: <IconPalette size={20} />, // Followers Icon
        edit: <IconEdit size={20} />, // Friends Icon
        delete: <IconTrash size={20} />, // Friends Icon
    };

    let sort = [
        {label: "Status", column: "status",},
        {label: "Name", column: "name",},
        {label: "Created Date", column: "created_date",},
    ]

    return (
        <>
            <PageTitle
                title={<>Push Test: {details.name === "Loading..." ? <span className="loading-text">Loading...</span> : details.name}</>}
                homeUrl={"/dashboard"} subTitle={"Details"}
                links={[{ name: "Push Tests", link: "/push-tests" }]}
                menuItems={tabs}
                menuIcons={icons}
                curPage={page}
                curID={id}
            />
            <div className={"card overflow-hidden invoice-application"}>
                <div className="d-flex">
                    <div className="w-25 d-none d-lg-block border-end user-chat-box">
                        <div className="app-invoice">
                            <ul className="overflow-auto invoice-users simplebar-scrollable-y" data-simplebar="init">
                                <div className="simplebar-wrapper" style={{margin: "0px"}}>
                                    <div className="simplebar-height-auto-observer-wrapper">
                                        <div className="simplebar-height-auto-observer"></div>
                                    </div>
                                    <div className="simplebar-mask">
                                        <div className="simplebar-offset" style={{right: "0px", bottom: "0px"}}>
                                            <div className="simplebar-content-wrapper" tabIndex="0" role="region"
                                                 aria-label="scrollable content"
                                                 style={{height: "100%", overflow: "hidden scroll"}}>
                                                <div className="simplebar-content" style={{padding: "0px"}}>
                                                    <SideBar id={id} sort={sort} object={"custom_tests"} path={"push-test"}  controller={CustomTest} refresh={refresh} setRefresh={setRefresh}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="simplebar-placeholder"
                                         style={{width: "280px", height: "459px"}}></div>
                                </div>
                                <div className="simplebar-track simplebar-horizontal" style={{visibility: "hidden"}}>
                                    <div className="simplebar-scrollbar" style={{width: "0px", display: "none"}}></div>
                                </div>
                                <div className="simplebar-track simplebar-vertical" style={{visibility: "visible"}}>
                                    <div className="simplebar-scrollbar"
                                         style={{
                                             height: "25px",
                                             display: "block",
                                             transform: "translate3d(0px, 0px, 0px)"
                                         }}></div>
                                </div>
                            </ul>
                        </div>
                    </div>
                    <div className="w-75 w-xs-100 chat-container">
                        <div className="invoice-inner-part h-100">
                            <div className="invoiceing-box">
                                <div id="custom-invoice">
                                    <MainDashboardContent tabs={tabs} page={page} id={id}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*
            <div style={{ fontFamily: "Arial, sans-serif" }}>
                <div style={{ display: "flex", flexDirection: "row", height: "100vh" }}>
                    <SideBar id={id} sort={sort} object={"custom_tests"} path={"push-test"}/>

                    <MainDashboardContent tabs={tabs} page={page} id={id} />
                </div>
            </div>
            */}
        </>
    );
};

export default PushTestsDashboard;
